<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="toggle-container">
    <label class="toggle-wrapper" :for="id">
      <input
        type="checkbox"
        :id="id"
        :checked="modelValue"
        :disabled="disabled"
        class="toggle"
        :aria-describedby="`${id}-help`"
        :class="{ 'p-invalid': validation?.$error }"
        @change="$emit('update:modelValue', $event.target.checked)"
      />
      <span class="toggle-slider"></span>
    </label>
    <span class="toggle-label" v-if="label">{{ label }}</span>
    <span
      v-if="validation?.$error && validation?.required?.$invalid"
      :id="`${id}-help`"
      class="p-error text-left mt-2 block"
    >
      {{ PropName }} is required.
    </span>
    <span
      v-else-if="
        validation?.$error &&
        validation?.requiredIf &&
        validation?.requiredIf.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2 block"
    >
      {{ validation.requiredIf.$message.replace('value', PropName) }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    sectionClass: {
      type: String,
      default: 'field',
    },
    id: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    validation: {
      type: Object,
      required: false,
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    PropName: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.toggle-container {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.toggle-wrapper {
  position: relative;
  display: inline-block;
  width: 2.5rem;
  height: 24px;
}

.toggle {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  // left: 0;
  right: 0;
  bottom: 0;
  border-radius: 20px;
  border: 1px solid #C0C0BC;
  background: #D8D8D5;
  transition: 0.4s;
  border-radius: 1.5rem;
  height: 28px !important;
    width: 50px !important;
    display: flex
;
}

.toggle-slider:before {
  position: absolute;
  content: '';
  height: 1.27rem;
  width: 1.27rem;
  left: 0.2rem;
  bottom: 0.2rem;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

.toggle:checked + .toggle-slider {
  background-color: #43a584;
    border-color: #348067;
}

.toggle:checked + .toggle-slider:before {
  transform: translateX(1.4rem);
}

// .toggle:focus + .toggle-slider {
//   outline: 2px solid #222222;
//   border: 1px solid #c0c0bc;
//   box-shadow: none;
// }

.toggle:disabled + .toggle-slider {
  background-color: #e9ecef;
  cursor: not-allowed;
}
.toggle:not(:checked) + .toggle-slider:hover {
 border: 1px solid #909088;
    background: #C0C0BC;
}
.toggle:checked + .toggle-slider:hover {
  background-color: #348067;
  border-color: #348067;
}

.toggle-label {
  margin-left: 0.5rem;
  vertical-align: middle;
  font-size: 1rem;
}

.p-error {
  color: #dc3545;
  font-size: 0.875rem;
}
</style>